module.exports = __webpack_public_path__ + "media/images/flags/QA-e202adef2ea2b89befb6116e735b4207.svg";